export class UserDelegation {
    cancelled: boolean;
    delegateToUserId: string;
    delegationId: string;
    userId: string;
    validFrom: string;
    validTo: string;
}
